import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { AIDES_COLLECTIVITES } from '../../../../config/aides-collectivites';

export default function BanqueTerritoiresPage() {
  const aide = AIDES_COLLECTIVITES.find((a) => a.slug === 'banque-territoires');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="collectivites" />;
}
